import React, { FC } from "react";
import { RadioGroup as MuiRadioGroup, RadioGroupProps } from "@mui/material";

const RadioGroup: FC<RadioGroupProps> = (props) => <MuiRadioGroup {...props} />;

export default RadioGroup;
